import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';

@Component({
  selector: 'tt-service-object-type',
  templateUrl: './service-object-type.component.html',
  styleUrls: ['./service-object-type.component.css']
})
export class ServiceObjectTypeComponent implements OnInit {
    serviceObjectTypeKeyno;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.serviceObjectTypeKeyno = this.stateService.getStateParams()['serviceobjecttype_keyno'];
    }

    private async loadEdit() {
        if (!!this.serviceObjectTypeKeyno) {
            this.edit = (await this.datatask.Post(1741, { serviceobjecttype_keyno: this.serviceObjectTypeKeyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1742, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    serviceobjecttype_keyno: number;
    serviceobjecttype_name: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('serviceObjectType', {
//        templateUrl: 'views/components/views/serviceObjectType/serviceObjectType.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'serviceObjectTypeService', function ($stateParams, stateService, translateService, modalService, serviceObjectTypeService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let serviceObjectTypeKeyno = $stateParams.serviceobjecttype_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            translateService.translateBatch(translations).then(function (data) {
//                angular.forEach(translations, function (_, key) {
//                    if (angular.isDefined(data[key])) {
//                        translations[key] = data[key];
//                    }
//                });
//            });

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE CALL

//            let loadEdit = function () {
//                serviceObjectTypeService.getEdit({ serviceobjecttype_keyno: serviceObjectTypeKeyno }).then(function (info) {
//                    angular.copy(info[0], vm.model.edit);
//                });
//            };

//            // #region LOAD PROCEDURE CALL

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                serviceObjectTypeService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadEdit();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
